module.exports = __webpack_public_path__ + "static/media/LukeCanfield.72ce91b1.png";